import { Component } from 'react'
import { Inventory } from 'stylewhere/api'
import { List, RowProps, StatusChip } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { getDatetime } from 'stylewhere/shared/utils'

interface Props extends RowProps {
  inventory: Inventory
  onClick: () => void
}

export class InventoryRow extends Component<Props> {
  render() {
    const { inventory, onClick, ...rest } = this.props
    return (
      <List.Row onClick={onClick} {...rest}>
        <List.Cell flex={0.5} label={__(T.misc.status)}>
          <StatusChip status={inventory.status} />
        </List.Cell>
        <List.Cell flex={1.5} label={__(T.misc.description)} value={inventory.description} />
        <List.Cell label={__(T.misc.creation_date)} value={getDatetime(new Date(inventory.creationDate).getTime())} />
      </List.Row>
    )
  }
}
